import React from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import A from "../../../common/A";
import { TYPE } from "../../../../constant";
import { useSound, useLearningData, useLearningBtn, useUserInfo, useWorksheet } from "../../../../hooks";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const TabLearning = withRouter((props) => {
  const { t, i18n } = useTranslation();
  const { info } = useUserInfo();
  const deviceInfo = useSelector(state => state.deviceInfo);
  const { learningData, setLearningData } = useLearningData();
  const [goLearning] = useLearningBtn();
  const { setSound, playSound, clearSound } = useSound();
  const { handleWorkSheet } = useWorksheet();

  const [first, setFirst] = React.useState({});
  const [firstClassName, setFirstClassName] = React.useState('on');
  const [list, setList] = React.useState([]);

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };

  const moveLearning = (e, stgCd, resumeYn) => {
    setSound({src : `${ process.env.PUBLIC_URL }/static/audio/common_button.ogg`});
    // playSound();
    setLearningData({ stgCd, prevPage: 'courseLearning' });
    setTimeout(() => {
      // clearSound();
      setAnsweringQuestions( { isResumeYn : resumeYn && resumeYn === 'Y' } )
      goLearning({
        stage: stgCd,
        lrnEntyScnCd: TYPE.LEARNING.COURSE,
        resumeYn : resumeYn
      });
    }, 0);
  };

  const changeList = () => {
    let learningResult = props.resultInfo?.lrnPrgsStsCd ? props.resultInfo.lrnPrgsStsCd : '';

      if(learningData.answeringQuestionsComplete && learningResult){
        if (
          props.resultInfo.lrnPrgsStsCd === 'LPSC02'
          || props.resultInfo.lrnPrgsStsCd === 'LPSC03'
          || props.resultInfo.lrnPrgsStsCd === 'LPSC04'
        ) {
          //결과값애니메이션후 완료학습 접히는 CSS
          setLearningData({resultFoldingFlag:true});
          setSound({src : `${ process.env.PUBLIC_URL }/static/audio/lc_03_02.ogg`});
          playSound();
          setFirstClassName("on ani_open");
        }else{
          //학습결과값이 노력일 경우이거나 props.resultInfo값이 없을경우(결과페이지에서 바로 안오는경우) 접히는 CSS 안함
          setFirstClassName("on");
        }
        setLearningData({answeringQuestionsComplete : false});
      }
      if(props?.list?.lrnCousList){
          let propList = props.list.lrnCousList;
          let courseLearningList = [];
            for(let i=0; i<propList.length; i++){
              if(i === 0){
                setFirst(propList[i]);
              }else{
                courseLearningList.push(propList[i]);
              }
            }
        setList(courseLearningList);
      }
  };

  const renderResult = () => {

    let status = 'red';
    if(props.resultInfo.lrnPrgsStsCd === "LPSC02"){
      status = 'yellow'
    }else if(props.resultInfo.lrnPrgsStsCd === "LPSC03"){
      status = 'green'
    }else if(props.resultInfo.lrnPrgsStsCd === "LPSC04"){
      status = 'purple'
    }

    setTimeout(()=>{
      clearSound();
      let obj = props?.levelResult ? props?.levelResult : {};
      if(Object.keys(obj).length > 0){
        props.completeLevelClassChange();
      }
      setLearningData({resultFoldingFlag:false});
      setFirstClassName("on");
    }, 2100);

    return(
      <article className={`on ${status} with_result on ani_fold back_card`}>
        <div className="head_wrap">
          <div className="num">{props.resultInfo?.rowNum}</div>
          <div className="tit"><span>{props.resultInfo?.stgNm}</span></div>
          <div className={clsx(
            "state cls",
            (info.channelCode === TYPE.CHANNEL.GLOBAL01 && props.resultInfo?.workSheetYn === 'Y') && 'wksh'
          )}>
            <div className="left">
              <Moment format="YYYY.MM.DD">
                {props.resultInfo?.lrnEndDt}
              </Moment>
            </div>
            <div className="right"><span>{props.resultInfo?.lrnPrgsStsCdNm}</span></div>
          </div>
        </div>
        <div className="cont_wrap">
          <div className="gray_box">
            <img src={`${props.resultInfo?.stgImgFilePath}${props.resultInfo?.stgImgFileNm}`} alt="" />
          </div>
          <div className="btn_wrap">
              <A className="btn btn_go">{t("LC_03_02.msg005")}</A>
          </div>
        </div>
      </article>
    );
  };

  const renderLearnigBox = () => {

    let status = '';
    const lrnPrgsStsCd = props.resultInfo.lrnPrgsStsCd ? props.resultInfo.lrnPrgsStsCd : first.lrnPrgsStsCd
    if (lrnPrgsStsCd === "LPSC01") {
      status = 'red';
    } 
    // else if (lrnPrgsStsCd === "LPSC02") {
    //   status = 'yellow'
    // } else if (lrnPrgsStsCd === "LPSC03") {
    //   status = 'green'
    // } else if (lrnPrgsStsCd === "LPSC04") {
    //   status = 'purple'
    // }
    return(
      <article className={clsx(
        firstClassName,
        first?.lrnEndDt && "with_result",
        `${status}  on ani_fold ani_open`
      )}>
        <div className="head_wrap">
          <div className="num">{first ? first?.rowNum : '0'}</div>
          <div className="tit"><span>{first ? first?.stgNm : ''}</span></div>
          {
            (lrnPrgsStsCd === 'LPSC01' && first?.lrnEndDt) && (
              <div className={clsx(
                "state cls",
                (info.channelCode === TYPE.CHANNEL.GLOBAL01 && first.workSheetYn === 'Y') && 'wksh'
              )}>
                <div className="left">
                  {first?.lrnEndDt ? <Moment format="YYYY.MM.DD">{first?.lrnEndDt}</Moment> : ''}
                </div>
                {
                  i18n.language === "ko" || deviceInfo.type === TYPE.DEVICE.PHONE
                    ? first?.lrnPrgsStsCd ? <div className="right"><span>{t("LC_03_02.msg008")}</span></div> : ''
                    : <div className="right"><span></span></div>
                }
              </div>

            )
          }
        </div>
        <div className="cont_wrap">
          <div className="gray_box">
            <img src={`${first?.stgImgFilePath}${first?.stgImgFileNm}`} alt="" />
          </div>
          {
            first?.resumeYn === "Y" && (
              <React.Fragment>
                <div className="btn_wrap two">
                  <A className="btn btn_ag" onClick={(e)=>moveLearning(e, first.stgCd)}>{t("LC_03_02.msg011")}</A>
                  <A className="btn btn_go re" onClick={(e)=>moveLearning(e, first.stgCd, first.resumeYn)}>{t("LC_03_02.msg012")}</A>
                </div>
                {
                  (info.channelCode === TYPE.CHANNEL.GLOBAL01 && first.workSheetYn === 'Y') && (
                    <div className="wsDwon_wrap">
                      <A onClick={() => handleWorkSheet(props.list?.resumeLeanInfo ? props.list?.resumeLeanInfo : first)}>
                        <button type="button">{t("LC_05_07_01.msg023")}</button>
                      </A>
                    </div>

                  )
                }
              </React.Fragment>
            )
          }
          { (first?.resumeYn === "N" || !first?.resumeYn) && 
            <React.Fragment>
              <div className="btn_wrap">
                <A className="btn btn_go" onClick={(e)=>moveLearning(e, first.stgCd)}>{t("LC_03_02.msg005")}</A>
              </div>
              {
                (info.channelCode === TYPE.CHANNEL.GLOBAL01 && first.workSheetYn === 'Y') && (
                  <div className="wsDwon_wrap">
                    <A onClick={() => handleWorkSheet(props.list?.resumeLeanInfo ? props.list?.resumeLeanInfo : first)}>
                      <button type="button">{t("LC_05_07_01.msg023")}</button>
                    </A>
                  </div>
                )
              }
            </React.Fragment>
          }
        </div>
      </article>
    )
  };

  const renderList = () => {

    if(list?.length > 0){
      return(
        list.map((item, index) => (
          <article key={index}>
            <div className="head_wrap">
              <div className="num">{item?.rowNum}</div>
              {
                info.channelCode === TYPE.CHANNEL.GLOBAL01
                  ? <div className="tit"><span>{item?.stgNm}</span></div>
                  : <div className="tit"><span>{index < 2 ? item?.stgNm : t("LC_03_02.msg009")}</span></div>
              }
            </div>
          </article>
        ))
      );
    }
  };

  React.useEffect(changeList, [props.list]);

  return (
    <>
        {learningData.resultFoldingFlag && renderResult()}
        {first?.stgCd && renderLearnigBox()}
        {renderList()}
    </>
  );

});

export default TabLearning;

